(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = Boolean(window.Shopify && Shopify.designMode);
  var productDetailSelector = [
    '.product__media-wrapper',
    '.product__info-container .product__title',
    '.product__info-container [id^="price-"]',
    '.product__info-container .product__description > *',
    '.product__info-container variant-selects',
    '.product__info-container variant-radios',
    '.product__info-container .product-form__quantity',
    '.product__info-container .product-form__buttons',
    '.product__info-container .product__accordion',
    '.product__info-container product-recommendations',
    '#MainContent .related-products'
  ].join(',');
  var targetSelector = [
    '#MainContent > .shopify-section',
    '#MainContent > section',
    '.footer .footer-block',
    '.footer .footer__content-top > *',
    '.footer .footer__content-bottom',
    productDetailSelector
  ].join(',');
  var exclusionSelector = [
    '.shopify-section-group-header-group',
    '.announcement-bar',
    'header',
    'nav',
    'dialog',
    '[role="dialog"]',
    '.drawer',
    '.modal',
    '.popup',
    '.predictive-search',
    '.cart-drawer',
    '.sticky-atc',
    '.shopify-app-block',
    '[id^="shopify-block-"]'
  ].join(',');
  var observer;
  var descriptionObserver;
  var mainSectionSelector = '#MainContent > .shopify-section, #MainContent > section';
  var longSectionViewportRatio = 2;

  function show(element) {
    element.classList.add('zr-reveal--visible');
    if (observer) observer.unobserve(element);
    if (descriptionObserver) descriptionObserver.unobserve(element);
  }

  function isExcluded(element) {
    // Translating this section would make its fixed card relative to the section.
    if (element.matches(mainSectionSelector) && element.querySelector('.diy-side-card-wrap')) {
      return true;
    }
    return Boolean(element.closest(exclusionSelector));
  }

  function isLongSection(element) {
    return element.getBoundingClientRect().height > window.innerHeight * longSectionViewportRatio;
  }

  function isRevealableChunk(element) {
    var tagName = element.tagName;
    return !isExcluded(element) &&
      tagName !== 'SCRIPT' &&
      tagName !== 'STYLE' &&
      tagName !== 'TEMPLATE' &&
      element.getBoundingClientRect().height > 1;
  }

  function getLongSectionChunks(section) {
    var semanticSelector = 'section, article, [data-zr-reveal-item]';
    var semanticChunks = Array.prototype.slice.call(
      section.querySelectorAll(semanticSelector)
    ).filter(function (element) {
      var semanticParent = element.parentElement && element.parentElement.closest(semanticSelector);
      return isRevealableChunk(element) && (!semanticParent || semanticParent === section);
    });

    if (semanticChunks.length > 1) return semanticChunks;

    var contentRoot = section.querySelector('.rte') || section.firstElementChild;
    if (!contentRoot) return semanticChunks;

    var chunks = Array.prototype.slice.call(contentRoot.children).filter(isRevealableChunk);

    if (chunks.length === 1 && isLongSection(chunks[0])) {
      var nestedChunks = Array.prototype.slice.call(chunks[0].children).filter(isRevealableChunk);
      if (nestedChunks.length > 1) chunks = nestedChunks;
    }

    return chunks.length > 1 ? chunks : semanticChunks;
  }

  function registerElement(element, index, description) {
    if (element.classList.contains('zr-reveal') || isExcluded(element)) return;

    element.classList.add('zr-reveal');
    var delay = description
      ? Math.min(Array.prototype.indexOf.call(description.children, element), 7) * 90
      : Math.min(index % 4, 3) * 70;
    element.style.setProperty('--zr-reveal-delay', delay + 'ms');

    if (reduceMotion || designMode || element.getBoundingClientRect().top < window.innerHeight * 0.12) {
      show(element);
    } else {
      (description ? descriptionObserver : observer).observe(element);
    }
  }

  function register(scope) {
    var context = scope && scope.querySelectorAll ? scope : document;
    var targets = Array.prototype.slice.call(context.querySelectorAll(targetSelector));

    if (context.matches && context.matches(targetSelector)) targets.unshift(context);

    targets.forEach(function (element, index) {
      if (element.classList.contains('zr-reveal') || isExcluded(element)) return;
      if (
        element.matches(mainSectionSelector) &&
        element.querySelector('.product__media-wrapper, .product__info-container')
      ) return;

      if (element.matches(mainSectionSelector) && isLongSection(element)) {
        getLongSectionChunks(element).forEach(function (chunk, chunkIndex) {
          registerElement(chunk, chunkIndex, null);
        });
        return;
      }

      var description = element.parentElement && element.parentElement.matches('.product__description')
        ? element.parentElement
        : null;
      registerElement(element, index, description);
    });
  }

  function init() {
    if (!('IntersectionObserver' in window) || reduceMotion || designMode) {
      root.classList.remove('zr-rise-reveal-enabled');
      return;
    }

    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) show(entry.target);
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -8% 0px'
    });

    descriptionObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) show(entry.target);
      });
    }, {
      threshold: 0,
      rootMargin: '0px 0px -4% 0px'
    });

    register(document);

    document.addEventListener('shopify:section:load', function (event) {
      register(event.target);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
